module.exports = __webpack_public_path__ + "static/media/money-bill-wave.ac5cb626.svg";